export const TRISA_BASE_URL = 'https://trisa.dev';
